fx.translations("en",{
    "Sauvegarde de votre mise en page ..." : "Saving your layout...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "HEIC images must be fully uploaded to be used for automatic creation.",

    "Aller à votre album" : "Go to your album",
    "Choisissez votre album en fonction de votre budget" : "Choose your album according to your budget",
    "Cliquez pour voir les détails" : "Click to see details",
    "Pour ajouter une Photo" : "To add a Photo",
    "Déplacez une photo depuis la galerie" : "Drag a photo from the gallery",
    "Sélectionnez au minimum une trentaine de photos" : "Select at least around thirty photos"
});

